import { Dispatch, SetStateAction } from 'react';
import { Filter } from 'types/Filter';
import { getFilterValuesForReset } from './filterHelper';

interface UseClearFilterHandlersOptions {
  filter: Filter;
  setFilter?: Dispatch<SetStateAction<Filter>>;
  onFilterChange?: (newFilter: Filter) => void;
  preserveOrdering?: boolean;
}

interface UseClearFilterHandlersResult {
  clearAppliedFilters: () => void;
  clearDraftFilters: () => void;
}

export const useClearFilterHandlers = ({
  filter,
  setFilter,
  onFilterChange,
  preserveOrdering = false,
}: UseClearFilterHandlersOptions): UseClearFilterHandlersResult => {
  const getResetFilter = (): Filter =>
    getFilterValuesForReset(filter, {
      preserveOrdering,
    });

  const clearAppliedFilters = (): void => {
    onFilterChange?.(getResetFilter());
  };

  const clearDraftFilters = (): void => {
    setFilter?.(getResetFilter());
  };

  return {
    clearAppliedFilters,
    clearDraftFilters,
  };
};
